export enum UserType {
  Anonymous = 'anonymous',
}

export interface UserProfile {
  id: string;
  name: string;
  type: UserType;
  last_connection: Date;
  created_at: Date;
  updated_at: Date;
}

export enum GameStatus {
  Lobby = 'lobby',
  Started = 'started',
  Ended = 'ended',
}

export enum GameMode {
  Standard = 'standard',
  '90s' = '90s',
  '80s' = '80s',
  '2000s' = '2000s',
  '2010s' = '2010s',
  Shooter = 'shooter',
  RPG = 'rpg',
  Adventure = 'adventure',
  Horror = 'horror',
  Action = 'action',
  Strategy = 'strategy',
  Sport = 'sport',
  Music = 'music',
  Racing = 'racing',
  Indie = 'indie',
  Platformer = 'platformer',
  Fantasy = 'fantasy',
  ScienceFiction = 'science-fiction',
  Drama = 'drama',
  Romance = 'romance',
  PlayStation = 'playstation',
  Nintendo = 'nintendo',
  XBOX = 'xbox',
  Sega = 'sega',
}

export enum GameType {
  Multi = 'multi',
  Challenge = 'challenge',
}

export interface GameHint {
  image_url: string;
}

export interface GameRoundScore {
  game: number;
  release_year: number;
  platform: number;
  attempts: number;
}

export interface GameRound {
  hint: GameHint;
  id: string;
  score: Record<string, GameRoundScore>;
  ends_at?: Date;
  answer?: {
    game: string;
    platforms: string[];
    release_year: number;
  };
}

export interface GamePlayer {
  id: string;
  name: string;
  score: number;
  last_ping: Date;
}

export interface GameSettings {
  max_rounds: number;
  round_duration: number;
  max_attempts: number | null;
  public: boolean;
  game_duration: number;
}

export interface Game {
  id: string;
  name: string;
  type: GameType;
  mode: GameMode;
  status: GameStatus;
  user: {
    id: string;
    name: string;
  };
  players: Record<string, GamePlayer>;
  rounds: Record<number, GameRound>;
  current_round: number;
  started_at: Date | null;
  ended_at: Date | null;
  settings: GameSettings;
  created_at: Date;
  updated_at: Date;
}
